import {Injectable} from '@angular/core';
import {environment} from '../../../../../environments/environment';
import {ReportTemplate} from '../../interfaces/ReportTemplate';
import {Pagination} from '../../../utilities/interfaces/Pagination';
import {AuthHttp} from '../../../user/services/auth/http/auth-http.service';

@Injectable()
export class ReportTemplateService {

  protected route = 'report-template';
  constructor(private http: AuthHttp) {}

  public getReports(limit: number = 10, page = 1): Promise<Pagination<ReportTemplate>> {
    return this.http.get(`${environment.baseUrl}${this.route}?limit=${limit}&page=${page}`).map((res) => res.json()).toPromise();
  }

  public create(reportTemplate: ReportTemplate) {
    return this.http.post(`${environment.baseUrl}${this.route}`, reportTemplate).map((res) => res.json()).toPromise();
  }

  public update(id, data) {
    console.log(data);
    return this.http.put(`${environment.baseUrl}${this.route}/${id}`, data).map((res) => res.json()).toPromise();
  }

  public getReport(id) {
    return this.http.get(`${environment.baseUrl}${this.route}/${id}`).map((res) => res.json()).toPromise();
  }

  public delete(id) {
    return this.http.delete(`${environment.baseUrl}${this.route}/${id}`).toPromise();
  }

}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/report/services/report-template/report-template.service.ts